import React, { useCallback, useEffect, useRef, useState } from "react"
import { useScrollToTop } from '@react-navigation/native';
import { ActivityIndicator, FlatList, ScrollView, View } from "react-native"
import { Icon } from "react-native-elements"
import { useDispatch, useSelector } from "react-redux"
import Colors from "../../constants/Colorsv2"
import { TouchableOpacity } from "../../globalComponents/NativeOverrides"
import { social_getPosts } from "../../store/actionsv1/social"
import { PublicPlayerProps } from "../../store/types/auth_svc"
import { PostProps } from "../../store/types/soc_svc"
import PostCard from "./components/PostCard"
import ProfileHeader from "./components/ProfileHeader"
import { AdServer, BEEventApi } from "be-components";

const ActivityFeed = ({ route, navigation }:any) => {
    const [ get_posts_attempts, setGetPostsAttempts ] = useState(0);
    const [ postsLoading, setPostsLoading ] = useState(false);
    const [ posts_offset, setPostsOffset ] = useState(0);
    const [ isScrollAtEnd, setIsScrollAtEnd ] = useState(false)

    const dispatch = useDispatch();
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.widht);
    const isAuthenticated:boolean = useSelector((state:any) => state.auth.isAuthenticated, (left, right) => left == right)
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const feed_posts:string[] = useSelector((state:any) => state.social.feed_posts, (left, right) => left.length === right.length)
    const stored_posts:PostProps[] = useSelector((state:any) => state.social.stored_posts, (left, right) => left.length == right.length)
    
    const ref = useRef(null);
    useScrollToTop(ref);

    useEffect(() => {
        setPostsLoading(true)
        getPostsFromServer(0, 'following')
    },[isAuthenticated])

    useEffect(() => {
        if(isScrollAtEnd && !postsLoading){ 
            setPostsLoading(true)
            getPostsFromServer(undefined, 'following')
         }
    },[isScrollAtEnd])

    useEffect(() => {
        if(postsLoading){ return }
        if(get_posts_attempts == 1 && feed_posts.length === 0){
            getPostsFromServer(0, 'following')
        }
    },[postsLoading])

    const getPostsFromServer = async(offset_override?:number, type?: string) => {
        let offset = offset_override ?? posts_offset + 1
        setGetPostsAttempts(get_posts_attempts + 1)
        await dispatch(social_getPosts(offset, type))
        setPostsOffset(offset)
        setPostsLoading(false)
    }

    const renderPosts = useCallback((data: {item: string, index:number}) => {
        const post = stored_posts.find(sp => sp.memo_post_id == data.item)
        if(!post || post.status !== 'visible'){ return <></> }
        return (
            <View key={`post:${data.item}`}>
                <PostCard navigation={navigation} post={post} view_type='feed' />
                {data.index % 5 == 0 ?
                <AdServer
                    placement='events_feed'
                    ad_type='medium_rectangle'
                    role={player?.type}
                    device_width={app_size.width}
                    onViewAd={(e) => BEEventApi.saveEvent(e)}
                    onClickAd={(e) => BEEventApi.saveEvent(e)}
                />
                :<></>}
            </View>
        )
    },[stored_posts.length])

    const loadMoreIfNeeded = ({ layoutMeasurement, contentOffset, contentSize }:any) => {
        if(postsLoading){ return }
        const paddingToBottom = 300
        const needMore = layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom
        if(needMore){ setIsScrollAtEnd(true) } else { setIsScrollAtEnd(false) }
    }

    return (
        <View style={{ flex:1 }}>
            <ScrollView key={'feed'} ref={ref} style={{ flex:1 }} showsVerticalScrollIndicator={false} onScroll={({ nativeEvent }) => {
                loadMoreIfNeeded(nativeEvent)
            }}
            scrollEventThrottle={400}>
                {player ?
                <ProfileHeader viewer_id={player.player_id} player={player} actions={['view']} onActionPress={(action) => navigation.push('SocialProfile', { player_id: player.player_id })}/>
                :<></>}
                <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
                    <FlatList
                        key='posts'
                     maxToRenderPerBatch={5} 
                     windowSize={50}
                     data={feed_posts} 
                     renderItem={renderPosts} 
                     keyExtractor={(id:string, index:number) => `${id}:${index}`}
                     />
                </View>
                <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                </View>
            </ScrollView>
            <TouchableOpacity style={{ position:'absolute', justifyContent:'center', alignItems:'center', bottom:20, right:20, height:50, width:50, backgroundColor:Colors.brand.electric, borderRadius:100 }} onPress={() => navigation.push('MemoPost', { type: 'new' })}>
                <Icon name='file-plus' type='feather' color={Colors.shades.white} size={18}/>
            </TouchableOpacity>
        </View>
    )
}


export default ActivityFeed